import { getCall_v2 } from "services";
import { sentenceCase } from "utils";

import {
  DETAILS_VIEW,
  RAW_SO_LISTING_API_URL,
  RAW_SO_LISTING_EXPORT_API_URL,
  RAW_HEADER_MAPPING_API_URL,
  FILE_UPLOAD_DOWNLOAD_API_URL,
} from "./constants";

const headerMappingCache = new Map();

// the fileengine QA host.
export const fetchRawAndMappedHeaderMapping = (actionType) => {
  if (!actionType) return Promise.resolve({});

  if (!headerMappingCache.has(actionType)) {
    const request = getCall_v2(RAW_HEADER_MAPPING_API_URL, { actionType })
      .then(({ data }) => data ?? {})
      .catch((err) => {
        // let a later render retry instead of caching a permanent failure
        headerMappingCache.delete(actionType);
        throw err;
      });
    headerMappingCache.set(actionType, request);
  }

  return headerMappingCache.get(actionType);
};

const buildColumnLabel = (key, view, headerMapping) =>
  view === DETAILS_VIEW.RAW
    ? headerMapping?.[key] ?? sentenceCase(key)
    : sentenceCase(key);

export const buildColumnsForView = (columnKeys, view, headerMapping) =>
  (columnKeys ?? []).map((key) => ({
    key,
    label: buildColumnLabel(key, view, headerMapping),
  }));

const buildStatusQuery = (statusFilters = []) =>
  statusFilters.length
    ? `status=${statusFilters.map(encodeURIComponent).join(",")}`
    : "status=";

export const buildRowsTableTitle = (statusFilters = [], count = 0) => {
  const prefix = statusFilters.length ? statusFilters.join(", ") : "All";
  return `${prefix} Rows (${count})`;
};

const fetchRawSoListing = (uploadId, statusFilters, page, pageSize) => {
  const url = `${RAW_SO_LISTING_API_URL}?${buildStatusQuery(statusFilters)}`;
  return getCall_v2(url, { uploadId, page, pageSize });
};

// a blob via useDownload rather than through getCall_v2
export const buildRawSoListingExportUrl = (statusFilters = []) =>
  `${RAW_SO_LISTING_EXPORT_API_URL}?${buildStatusQuery(statusFilters)}`;

// param and never needs refetching just because the view toggle changed.
export const fetchUploadRows = async ({
  uploadId,
  statusFilters = [],
  page = 0,
  pageSize = 10,
} = {}) => {
  const { data: response } = await fetchRawSoListing(
    uploadId,
    statusFilters,
    page,
    pageSize,
  );
  const payload = response?.data ?? {};

  return {
    data: {
      columnKeys: payload.columns ?? [],
      rows: payload.records ?? [],
      totalCount: payload.pagination?.totalRecords ?? 0,
      availableStatuses: payload.availableStatuses ?? [],
    },
  };
};

export const buildFileDownloadUrl = (requestId) =>
  `${FILE_UPLOAD_DOWNLOAD_API_URL}/${requestId}/download`;
